import { Skeleton } from '@/components/ui/skeleton'

export const NavUserSkeleton = () => {
  return (
    <div className="flex h-10 w-32 shrink-0 items-center justify-center gap-3 rounded-2xl lg:h-10">
      <Skeleton className="flex h-6 w-12 shrink-0 items-center justify-center overflow-hidden rounded-2xl"></Skeleton>
      <Skeleton className="flex h-6 w-14 shrink-0 items-center justify-center overflow-hidden rounded-2xl"></Skeleton>
    </div>
  )
}
